/**
 * Shopify chat (Shopify Inbox / shopify-agent): sposta il pulsante flottante
 * a bottom:20px su DESKTOP (>=990px).
 * Il widget vive in uno shadow DOM, quindi non è raggiungibile dal CSS del tema:
 * qui impostiamo lo stile inline direttamente sull'elemento .activator-nudge,
 * sia che stia nel light DOM sia nello shadow DOM APERTO di <shopify-agent>.
 * Nota: se lo shadow DOM fosse "closed", nemmeno il JS può entrarci (in quel caso
 * l'unica leva è la posizione impostata da Shopify Inbox).
 */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 990px)';
  var OFFSET = '20px';

  function styleNudge(root) {
    if (!root) return false;
    var nudge = root.querySelector && root.querySelector('.activator-nudge');
    if (!nudge) return false;
    if (window.matchMedia(DESKTOP).matches) {
      nudge.style.setProperty('bottom', OFFSET, 'important');
    } else {
      nudge.style.removeProperty('bottom');
    }
    return true;
  }

  function apply() {
    // 1) light DOM
    if (styleNudge(document)) return true;
    // 2) shadow DOM aperto di <shopify-agent>
    var host = document.querySelector('shopify-agent');
    if (host && host.shadowRoot && styleNudge(host.shadowRoot)) return true;
    return false;
  }

  // Il widget viene iniettato in modo asincrono: osservo il DOM finché compare,
  // poi resto in ascolto per riapplicare se Shopify ri-renderizza il pulsante.
  var observer = new MutationObserver(function () { apply(); });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // riapplica al cambio di viewport (desktop <-> mobile)
  window.addEventListener('resize', apply);

  apply();
})();
